import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from 'reactstrap'
import CaregiverContent from "./CaregiverContent";
import CaregiverMenu from "./CaregiverMenu";
import { useDispatch, useSelector } from "react-redux";
// import NotesTab from "../../General/NotesTab/NotesTab";
import CaregiverNotesTab from "../../General/NotesTab/CaregiverNotesTab";
import { OpenNewCaregiverTabAction } from "../../../actions/CaregiverActions";
import ContentReceiver from "../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";
import AddAlert from "../../General/AddAlert";
import ActiveAlert from "../../General/ActiveAlert";
import isNull from "../../../utils/NullChecking";
import AddNewTask from "../../Home/TaskManagement/AddNewTask";
import AddNewAppointment from "../../Scheduler/AddNewAppointment";
import CustomUseRef from "../../shared/DropDown/CustomUseRef";
import MergeCaregiver from "../CaregiverOptions/MergeCaregiver/MergeCaregiver";

const CaregiverTopMenu = (props) => {
    let CaregiverID = useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true));
    let CaregiverName =  useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true))?.data?.name;
    let isPateintSubTapOpen = false
    let CaregiverTab = useSelector(state => state.Open_Caregiver_Tab);
    let CaregiverActiveSub = CaregiverTab[CaregiverTab.length - 1]?.data?.type;
    const [CaregiverActiveSubTab, setCaregiverActiveSubTab] = useState(CaregiverActiveSub);
    console.log("CaregiverActiveSubTab",CaregiverActiveSubTab,CaregiverTab)
    let isNewPtSaved = useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true));
    let dispatch = useDispatch();
    let CaregiverData = useSelector(state => state.CaregiverRecordReducer);
    let FirstCaregiver;
    let LastPateint;

    if (CaregiverData.length > 0) {
        FirstCaregiver = CaregiverData[0]
        LastPateint = CaregiverData[CaregiverData.length - 1]
    }
    if (isNewPtSaved && isNewPtSaved.data) {
        isNewPtSaved = isNewPtSaved.data.newCaregiver;
    }
    if (CaregiverID && CaregiverID.data) {
        isPateintSubTapOpen = CaregiverID.data.isPateintSubTapOpen;
        CaregiverID = CaregiverID.data.id;
    }
    // if (CaregiverName && CaregiverName.data) {
    //     CaregiverName = CaregiverName.data.name;
    // }
    const MenuItems = CaregiverMenu();
    const [subCategItems, setSubCategItems] = useState([])
    const [tabList, setTabsList] = useState([])
    const [activeTab, setActiveTab] = useState()
    const [subMenuActive, setSubMenuActive] = useState(false);
    const [openTab, setOpenTab] = useState('')
    const [isOpenAlertType, setisOpenCategoryType] = useState(false)
    const [isAlertVisible, setAlertVisible] = useState(false);
    const [TaskID, SetTaskID] = useState()
    const [Isopen, setIsopen] = useState(false);
    const [isClose, setIsClose] = useState();
    const [patientModal, setCaregiverModal] = useState(false);
    const [appointmentID, setAppointmentID] = useState("")
    const [mergeEvent, setMergeEvent] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [IsActivePtPayments, setIsActivePtPayments] = useState(false)

    useEffect(()=>{
        setCaregiverActiveSubTab(CaregiverTab[0]?.data?.type);
        console.log("CaregiverActive",CaregiverActiveSubTab,CaregiverTab,CaregiverTab[0]?.data?.type)
    },[CaregiverTab])
    // useEffect(() => {
    //     const handleOutsideClick = (event) => {
    //         const menuButton = document.querySelector(".btn-icon-transparent.dots-menu");
    //         const submenu = document.querySelector(".claims-TabHeader__right__submenu");

    //         if (submenu && !submenu.contains(event.target) && menuButton && !menuButton.contains(event.target)) {
    //             setSubMenuActive(false);
    //         }
    //     };

    //     if (subMenuActive) {
    //         document.addEventListener("click", handleOutsideClick);
    //     }

    //     return () => {
    //         document.removeEventListener("click", handleOutsideClick);
    //     };
    // }, [subMenuActive]);
    useEffect(() => {

        // console.log(FirstCaregiver,"ffff",LastPateint,'last');
        const selected_Item_List = MenuItems.filter((item) => item.key === props.subCategKey);
        if (selected_Item_List && selected_Item_List.length > 0) {
            let subCategories = selected_Item_List[0].subCategoryItems
            console.log("PATIENTID",CaregiverID)
            if (CaregiverID != -1) {
                if (isNewPtSaved === true) {
                    console.log("NEWPATIENTTRUE",subCategories[1])
                    setSubCategItems(subCategories)
                    setActiveTab(subCategories[1].key)
                    handleActiveTab(subCategories[1])
                } else {
                    setSubCategItems(subCategories)
                    if (CaregiverActiveSubTab) {
                        if (CaregiverActiveSubTab === "Demographics") {
                            setActiveTab(subCategories[0].key)
                            setTabsList([subCategories[0]])
                            handleActiveTab(subCategories[0])
                        }
                        else if (CaregiverActiveSubTab === "Insurances") {
                            setActiveTab(subCategories[2].key)
                            setTabsList([subCategories[2]])
                            handleActiveTab(subCategories[2])
                        }
                        else {
                            setActiveTab(subCategories[0].key)
                            handleActiveTab(subCategories[0])
                        }
                    }
                    else {
                        setActiveTab(subCategories[0].key)
                        handleActiveTab(subCategories[0])
                    }
                }
            } else {
                console.log("NEWPATIENTTRUE",subCategories)
                let NewCaregiver = subCategories.filter((item) => {
                    if (item.key === 212) {
                        return item
                    }
                })
                setSubCategItems(NewCaregiver)
                setActiveTab(NewCaregiver[0].key)
                handleActiveTab(NewCaregiver[0])
            }
            setAlertVisible(true);
        }
    }, [props.subCategKey])
    const handleCreateAlert = () => {
        setisOpenCategoryType(true);
    };
    const handleActiveTab = (item) => {
        console.log("activeTabElement",item,activeTab)
        const { key, name, right, component } = { ...item }
        let dynamicTabs = [...tabList]
        if (tabList.length === 0) {
            const activeTabElement = subCategItems.filter((item) => item.key === activeTab)
            const obj = {
                key: activeTabElement.key,
                name: activeTabElement.name,
                right: activeTabElement.right,
                component: activeTabElement.component,
            }
            dynamicTabs.push(obj)
        }
        const newTabObject = {
            key: key,
            name: name,
            right: right,
            component: component,
        }
        const isTabExist = dynamicTabs.filter((tab) => {
            return tab.name === name
        })
        if (!(isTabExist && isTabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newTabObject]
            setTabsList(dynamicTabs)
        }
        if (activeTab !== key) {
            setActiveTab(key)
        }
    }
    const handleNext = () => {
        let nextCaregiverid;
        let nextCaregiverName;
        for (let i = 0; i < CaregiverData.length; i++) {
            let item = CaregiverData[i]
            if (item.ID === CaregiverID) {
                nextCaregiverid = CaregiverData[i + 1]['ID']
                nextCaregiverName = CaregiverData[i + 1]['name']
            }
        }
        let obj = {
            key: 2,
            name: "Caregiver",
            active: true,
            data: {
                id: nextCaregiverid + "",
                name: nextCaregiverName,
                time: new Date(),
            },
        };
        let updatedData = CaregiverTab.filter((item) => item.data.id !== nextCaregiverid)
            .map((item) => {
                if (item.data.id === CaregiverID) {
                    return obj;
                }
                return item;
            });
        dispatch(OpenNewCaregiverTabAction(updatedData))
    }
    const handleBack = () => {
        let nextCaregiverid;
        let nextCaregiverName;
        for (let i = 0; i < CaregiverData.length; i++) {
            let item = CaregiverData[i]
            if (item.ID === CaregiverID) {
                nextCaregiverid = CaregiverData[i - 1]['ID']
                nextCaregiverName = CaregiverData[i - 1]['name']
            }
        }

        let obj = {
            key: 2,
            name: "Caregiver",
            active: true,
            data: {
                id: nextCaregiverid + "",
                name: nextCaregiverName,
                time: new Date(),
            },
        };
        let updatedData = CaregiverTab.filter((item) => item.data.id !== nextCaregiverid)
            .map((item) => {
                if (item.data.id === CaregiverID) {
                    return obj;
                }
                return item;
            });
        dispatch(OpenNewCaregiverTabAction(updatedData))
    }
    const handleViewAllClaim = () => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    CaregiverID: CaregiverID,
                    CaregiverName: CaregiverName,
                },
            },
        };
        setOpenTab(dataObj)
    }
    const CreateProfessionalClaim = () => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Professional",
                id: -1,
                time: new Date(),
                visitType: "P",
            },
        };
        setOpenTab(dataObj)
    }
    let Alert = ""
    if (isAlertVisible && !isNull(CaregiverID)) {
        Alert = <ActiveAlert alertFrom={'Caregiver'} ID={CaregiverID}  display={`Caregiver ${CaregiverName}`}/>
    }
    const CreateInstitutionalClaim = () => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Institutional",
                id: -2,
                time: new Date(),
                visitType: "I"
            },
        };
        setOpenTab(dataObj)
    }
    const handleCreateTask = () => {
        SetTaskID('0');
        setIsopen(true);
    }
    const [reload, setReload] = useState(false)
    const handleReloadCaregiver = () => {
        setReload(!reload)
    }


    const DeleteTask = () => {
        setIsopen(false)
        setIsClose((Math.random()));
    }
    const open = () => {
        setIsopen(true)
    }
    const close = () => {
        setIsopen(false)
    }

    let popupScreen = ""
    if (Isopen) {
        popupScreen = <AddNewTask IsOpen={open} IsClosed={close} onDeleteTask={DeleteTask} Task={TaskID} selectedPateintID={FirstCaregiver} PateintName={'Pateint'} />
    }

    const handleCreateAppointment = () => {
        setAppointmentID('0')
        setShowEvents(true);
    }
    const handleOnClose = () => {
        setShowEvents(false);
    }

    let popUp = "";
    if (showEvents) {
        popUp = <AddNewAppointment AppointmentID={appointmentID} showEvents={showEvents} handleOnClose={handleOnClose} CaregiverID={CaregiverID} />;
    }

    // const handleOpenTask = () => {
    //     setisOpenTask(true)
    //   }
    //   const onCloseChangeTask = () => {
    //     setisOpenTask(false)
    //   }
    //   const DeleteTask = () => {
    //     setisOpenTask(false)
    //     // setIsClose((Math.random()));
    // }
    // let TaskPopup = '';
    // if (isOpenTask) {
    //   TaskPopup = <AddNewTask IsOpen={isOpenTask} IsClosed={onCloseChangeTask} onDeleteTask={DeleteTask} selectedPateintID={FirstCaregiver} PateintName ={'Pateint'} />
    // }
    //////////////////////////
    const handleMergeCaregiver = (patientID) => {
        setMergeEvent(true);
    }
    const handleMergeClose = () => {
        setMergeEvent(false);
    }
    let MergePopup = '';
    if (mergeEvent) {
        MergePopup = <MergeCaregiver mergeEvent={mergeEvent} onClose={handleMergeClose} />
    }
    //////////////////////////
    const closeDropdown = () => {
        setSubMenuActive(false)

    };
    const handleSubMenu = (e) => {
        setSubMenuActive(!subMenuActive)
        e.stopPropagation();

    }

    return (
        <div className='app-tabs claims-TabHeader border-0'>
            {Alert}
            {popupScreen}
            {popUp}
            {MergePopup}
            <div className="d-flex justify-content-between br-clr br-bottom-1 child-sticky-tab">
                <Nav className="rb-tabs-v3">
                    {subCategItems && subCategItems.map((item) => {
                        return (
                            <React.Fragment key={item.key}>
                                <NavItem onClick={() => handleActiveTab(item)}>
                                    <NavLink href="#" className={activeTab === item.key ? "py-2 active" : "py-2"}>
                                        <i className={item.icon} /> {item.name}
                                    </NavLink>
                                </NavItem>
                            </React.Fragment>
                        );
                    })}
                </Nav>
                {isPateintSubTapOpen !== true ?
                    <>
                        {CaregiverID && CaregiverID !== -1 ?
                            <div className="claims-TabHeader__right">
                                <span class="icon-Reloading-icon1 fs-19" onClick={handleReloadCaregiver}><span class="path1"></span><span class="path2"></span></span>
                                <button className={FirstCaregiver && CaregiverID === FirstCaregiver.ID ? "btn disable" : "btn"} onClick={handleBack}>
                                    <i className="icon-Icon-ionic-md-arrow-round-back"></i>
                                </button>
                                <button className={LastPateint && CaregiverID === LastPateint.ID ? "btn disable" : "btn"} onClick={handleNext}>
                                    <i className="icon-arrow-right"></i>
                                </button>
                                <button
                                    className="btn-icon-transparent dots-menu"
                                    onClick={handleSubMenu}
                                >
                                    <i className="icon-dots-menu"></i>
                                </button>
                                {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                    {
                                        <div className={`claims-TabHeader__right__submenu ${subMenuActive && "active"}`}>
                                            {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
                                            <div className="itemList">
                                                <div className="itemList__item" onClick={handleViewAllClaim}>
                                                    View All Claims
                                                    <button
                                                        className="btn-icon-transparent"
                                                        onClick={() => setSubMenuActive(!subMenuActive)}
                                                    >
                                                        {/* <i className="icon-Icon-metro-cross"></i> */}
                                                    </button>
                                                </div>
                                                <div className="itemList__item" onClick={CreateProfessionalClaim}>Create Professional Claim</div>
                                                <div className="itemList__item" onClick={CreateInstitutionalClaim}>Create Institutional Claim</div>
                                                <div className="itemList__item" onClick={() => handleCreateTask()}>Create Task</div>
                                                <div className="itemList__item">Post Payment</div>
                                                <div className="itemList__item" onClick={handleCreateAlert}>Create Alert</div>
                                                <div className="itemList__item" onClick={() => handleCreateAppointment(CaregiverID)}>Create Appointment</div>
                                                <div className="itemList__item" onClick={() => handleMergeCaregiver(CaregiverID)}>Merge Caregiver</div>
                                            </div>
                                        </div>}
                                </CustomUseRef>}

                            </div>
                            : ''}
                    </>
                    : null}
                {/* <NotesTab name={'Caregiver'} /> */}
                {CaregiverID && CaregiverID !== -1 ? <CaregiverNotesTab /> : null}
            </div>
            <CaregiverContent activeTab={activeTab} dynamicTabs={tabList} subCategItems={subCategItems} Reload={reload} />
            <AddAlert isOpenAlertType={isOpenAlertType} onClose={() => setisOpenCategoryType(false)} loadAlertData={null} type={'Caregiver'} />
        </div>
    );
}

export default CaregiverTopMenu